class QuickViewBtn extends MenuDrawer {
  constructor() {
    super();
    this.productUrl = this.dataset.productUrl;
    this.popup = document.querySelector('.product-popup-modal');
    this.popupContents = document.querySelector('frame-popup .main__popup-container');
    
    this.init()
  }
  init() {
    this.addEventListener("click", (event) => {
      console.log(event)
      console.log(this.productUrl)
      this.popupContents.setAttribute('data-product-url', this.productUrl);
      this.popupContents.style.display = 'flex';
    })
  }
}
customElements.define('quick-view-btn', QuickViewBtn);

class FrameContent extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    new IntersectionObserver(this.handleIntersection.bind(this)).observe(this);
  }

  handleIntersection(entries, _observer) {
    if (!entries[0].isIntersecting) return;

    // const selector = this;
    const selector = '.quick-view__content';
    const drawerContent = this.querySelector(selector);
    // const drawerContent = this;
    const productUrl = this.dataset.productUrl.split('?')[0];
    const sectionUrl = `${productUrl}?view=modal`;
    console.log(sectionUrl)

    fetch(sectionUrl)
      .then(response => response.text())
      .then(responseText => {
        console.log(responseText);
        setTimeout(() => {
          const responseHTML = new DOMParser().parseFromString(responseText, 'text/html');
          console.log(responseHTML);
          const productElement = responseHTML.querySelector(selector);
          console.log(productElement);
          this.setInnerHTML(drawerContent, productElement.innerHTML);

          if (window.Shopify && Shopify.PaymentButton) {
            Shopify.PaymentButton.init();
          }
        }, 200);

        setTimeout(() => {
          drawerContent.classList.add('hide-cover');

          document.dispatchEvent(new CustomEvent('quickview:loaded', {
            detail: {
              productUrl: this.dataset.productUrl
            }
          }));
        }, 500);

        document.querySelector('body').classList.add('quick-view--open')
        this.closest('frame-popup').setAttribute('open', 'open');
        
      })
      .catch(e => {
        console.error(e);
      });
  }

  setInnerHTML(element, html) {
    element.innerHTML = html;

    // Reinjects the script tags to allow execution. By default, scripts are disabled when using element.innerHTML.
    element.querySelectorAll('script').forEach(oldScriptTag => {
      const newScriptTag = document.createElement('script');
      Array.from(oldScriptTag.attributes).forEach(attribute => {
        newScriptTag.setAttribute(attribute.name, attribute.value)
      });
      newScriptTag.appendChild(document.createTextNode(oldScriptTag.innerHTML));
      oldScriptTag.parentNode.replaceChild(newScriptTag, oldScriptTag);
    });
  }
}
customElements.define('frame-content', FrameContent);
